const baseSvg = (content, extraAttrs = '') =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ${extraAttrs}>${content}</svg>`

const syncPlus = baseSvg(`
  <path d="M21 12a9 9 0 0 0-15-6" />
  <polyline points="6 3 6 7 10 7" />
  <path d="M3 12a9 9 0 0 0 15 6" />
  <polyline points="18 21 18 17 14 17" />
  <line x1="12" y1="9" x2="12" y2="15" />
  <line x1="9" y1="12" x2="15" y2="12" />
`)

const circleCheck = baseSvg(
  `<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
  <path d="M8.5 12L11.5 14.5L15.5 9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />`
)

const creditCard = baseSvg(`
  <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
  <line x1="1" y1="10" x2="23" y2="10" />
`)

const documentText = baseSvg(`
  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
  <polyline points="14 2 14 8 20 8" />
  <line x1="16" y1="13" x2="8" y2="13" />
  <line x1="16" y1="17" x2="8" y2="17" />
  <polyline points="10 9 9 9 8 9" />
`)

const pix = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="2" aria-hidden="true"><path d="M4 4h6v6H4V4Zm10 10h6v6h-6v-6Zm0-10h6v6h-6V4Zm-4 10h.01v.01H10V14Zm0 4h.01v.01H10V18Zm-3 2h.01v.01H7V20Zm0-4h.01v.01H7V16Zm-3 2h.01v.01H4V18Zm0-4h.01v.01H4V14Z"/><path d="M7 7h.01v.01H7V7Zm10 10h.01v.01H17V17Z"/></svg>`

export const iconMap = {
  'sync-plus': syncPlus,
  'circle-check': circleCheck,
  'credit-card': creditCard,
  'document-text': documentText,
  'pix': pix
}

export const defaultIconName = 'sync-plus'

export function getIcon (name) {
  if (!name) return iconMap[defaultIconName]
  const exact = iconMap[name]
  if (exact) return exact
  const lower = (name || '').toLowerCase()
  const key = Object.keys(iconMap).find(k => k.toLowerCase() === lower)
  return iconMap[key] || iconMap[defaultIconName]
}



// WEBPACK FOOTER //
// ./src/assets/icons/index.js